import { AppRouter } from 'marionette';

let Router = AppRouter.extend({
  appRoutes: {
    '?client/settings/payment_processing': 'showPaymentProcessing',
    '?client/settings/payment_processing/': 'showPaymentProcessing',
    '?client/settings/payment_processing/add_gateway': 'addGateway',
    '?client/settings/payment_processing/add_gateway/': 'addGateway',
    '?client/settings/payment_processing/edit_gateway/:gatewayConfigID': 'editGateway',
    '?client/settings/payment_processing/edit_gateway/:gatewayConfigID/': 'editGateway',
    '?client/settings/payment_processing/add_terminal/:gatewayConfigID': 'addTerminal',
    '?client/settings/payment_processing/add_terminal/:gatewayConfigID/': 'addTerminal',
    '?client/settings/payment_processing/edit_terminal/:terminalID': 'editTerminal',
    '?client/settings/payment_processing/edit_terminal/:terminalID/': 'editTerminal',
  },
  onRoute() {
    /**
     * onRoute method gets called automatically when the appRoute matches,
     * it takes in "name, path, arguments" by default
     * We hide the admin tab, and show the view.
     * This may have to change to a more complicated logic when recreate the Settings landing page.
     */

    window.merchantos.tabs.close('admin');
  },
});

export default class SettingsRouter extends Router {}
